import { useEffect, useMemo, useSyncExternalStore } from 'react';
import { getFeedSession } from '../services/homeFeedSession';

export default function useHomeFeed(accountId, readOnly = false, activeTab = 'all') {
  const session = useMemo(() => getFeedSession(accountId), [accountId]);
  const getSnapshot = useMemo(() => {
    let selected;
    return () => {
      const state = session.getSnapshot();
      const feed = state.feeds[activeTab];
      const featured = state.feeds.all.featured;
      if (!selected || selected.feed !== feed || selected.featured !== featured || selected.online !== state.online || selected.hydrated !== state.hydrated) {
        selected = { feed, featured, online: state.online, hydrated: state.hydrated };
      }
      return selected;
    };
  }, [session, activeTab]);
  // Background prefetches for other tabs must not render the visible list.
  const state = useSyncExternalStore(session.subscribe, getSnapshot);
  useEffect(() => {
    if (!readOnly && activeTab === 'winners' && state.hydrated && state.online && !state.feed.loaded && !state.feed.loading) void session.load('winners', true);
  }, [session, readOnly, activeTab, state.hydrated, state.online, state.feed.loaded, state.feed.loading]);
  useEffect(() => {
    if (readOnly) session.suspend();
    session.setOnline(!readOnly && navigator.onLine !== false);
    void session.start();
    const connection = () => session.setOnline(!readOnly && navigator.onLine !== false);
    const created = () => { session.invalidate(); };
    const updated = ({ detail }) => {
      const patch = detail?.backendPost || detail?.updates;
      if (detail?.postId && patch) session.updatePost(detail.postId, patch);
      else created();
    };
    const deleted = ({ detail }) => { if (detail?.postId) session.removePost(detail.postId); };
    const blocked = ({ detail }) => { if (detail?.userId) session.removeAuthor(detail.userId); };
    const events = { online: connection, offline: connection, postCreated: created, postUpdated: updated, postDeleted: deleted, 'amposter:user-blocked': blocked };
    Object.entries(events).forEach(([name, handler]) => window.addEventListener(name, handler));
    return () => Object.entries(events).forEach(([name, handler]) => window.removeEventListener(name, handler));
  }, [session, readOnly]);
  return { ...state, session };
}
